import { VerificationEvents } from 'shared/constants/datalayer';
import { VerificationType } from 'shared/dataLayer';

export const verificationEventsBack = (arg_type: string, verificationType: VerificationType) => [
	VerificationEvents.VERIFICATION_1_BACK(verificationType),
	VerificationEvents.VERIFICATION_2_BACK(verificationType),
	VerificationEvents.VERIFICATION_3_BACK(arg_type, verificationType),
	VerificationEvents.VERIFICATION_4_BACK(verificationType),
	VerificationEvents.VERIFICATION_5_BACK(verificationType),
	VerificationEvents.VERIFICATION_6_BACK(verificationType),
];

export const verificationEventsForwards = (verificationType: VerificationType) => [
	VerificationEvents.VERIFICATION_1_FINISHED(verificationType),
	VerificationEvents.VERIFICATION_2_FINISHED(verificationType),
	VerificationEvents.VERIFICATION_3_FINISHED(verificationType),
	VerificationEvents.VERIFICATION_4_FINISHED(verificationType),
	VerificationEvents.VERIFICATION_5_FINISHED(verificationType),
	VerificationEvents.VERIFICATION_6_FINISHED(verificationType),
];
